// extracted by mini-css-extract-plugin
export default {"languageSelector":"speech_languageSelector__4VSeE"};